import * as t from 'ts-schema';
const collectionListingSchema = t.object({
  canonicalUrl: t.union(t.string, t.literal(null)),
  description: t.string,
  displayed: t.boolean,
  htmlPageTitle: t.string,
  id: t.number,
  metaDescription: t.string,
  name: t.string,
  slug: t.string,
  tagline: t.string,
  title: t.string,
  updatedAt: t.number
});
export const collectionSchema = t.object({
  createdAt: t.number,
  draftListing: t.union(collectionListingSchema, t.literal(undefined)),
  id: t.number,
  internalName: t.string,
  publishedListing: t.union(collectionListingSchema, t.literal(undefined)),
  type: t.union(t.literal('DYNAMIC'), t.literal('STATIC'))
});
export const collectionsResponseSchema = t.object({
  collections: t.array(collectionSchema)
});